<div class="w-full p-6">
    <!-- <div class="breadcrumb-wrap-list mb-6">
        <ul>
            <li>{{LABELS.CONFIGURATION}}</li>
        </ul>
    </div> -->
    <div class="whiteCard  p-5 my-2">
        <div class="flex items-center justify-between flex-wrap gap-x-1 gap-y-3">
            <div>
                <div class="titleWithBorder flex items-center gap-1.5 !mb-1 justify-between">{{LABELS.CONFIGURATION}}
                    <!-- <span (click)="onRefreshTable()" class="refresh-btn cursor-pointer leading-none flex" [matTooltip]="'Refresh'"><mat-icon>autorenew</mat-icon></span> -->
                </div>
            </div>
            <!-- <div>
                    <button class="-ml-4 btn-theme-color !min-w-[90px]" mat-button type="button" (click)="onRefreshTable()">Refresh</button>
                </div> -->
        </div>
        <div class="modal-inner p-5">
            <form (ngSubmit)="addEdit()" [formGroup]="configForm" class="w-full" id="ngForm" name="configForm"
                novalidate>
                <mat-card-content class="site-card-inner">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                        <!-- -->
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center">
                                <span class=" mb-5 font-bold">1 Euro (€) = </span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="grimConversionRate"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                    @if (configForm.controls.grimConversionRate.errors?.required){
                                    <mat-error class="">
                                        {{LABELS.GRIM_CONVERSION_RATE_REQUIRED}}
                                    </mat-error>
                                    }
                                </mat-form-field>
                                <span class="shrink-0 mb-5 font-bold">GRIMS</span>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">Daily Free Try-On</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="dailyFreeTryonCount"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class="shrink-0 mb-5 font-bold">Used Item Seller Fee</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" max="100" formControlName="usedItemSellerFee"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)"
                                        (input)="validateMax100($event, 'usedItemSellerFee')">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </div>
    </div>
    <div class="whiteCard  p-5 my-2">
        <div class="flex items-center justify-between flex-wrap gap-x-1 gap-y-3">
            <div>
                <div class="titleWithBorder flex items-center gap-1.5 !mb-1 justify-between">
                    {{LABELS.INCENTIVE_CONFIGURATION}}
                </div>
            </div>
        </div>
        <div class="modal-inner p-5">
            <form (ngSubmit)="addEdit()" [formGroup]="configForm" class="w-full" id="ngForm" name="configForm"
                novalidate>
                <mat-card-content class="site-card-inner">
                    <span class="shrink-0 mb-5 font-bold underline">One Time:</span>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 border-b-4 mb-2">
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">First Like:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="likes"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">First Comment:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="comments"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">First purchase:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="purchases"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">First purchase second hand:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="secondHandPurchases"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">First swap:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="secondHandSwaps"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">First Time Login:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="logins"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <span class="shrink-0 my-5 font-bold underline">Closet Item Uploads:</span>
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" formArrayName="closetItemUploads">

                        <div class="flex flex-col gap-2" *ngFor="let cip of closetItems.controls; let i = index"
                            [formGroupName]="i">
                            <div class="w-full flex gap-2 items-center justify-between">

                                <span class="mb-5 font-bold">
                                    {{ cip.get('itemUploaded')?.value }} {{cip.get('itemUploaded')?.value > 1 ? 'item
                                    uploads' : 'item upload'}}
                                </span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="earnings"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </div>
    </div>
    <div class="whiteCard  p-5 my-2">
        <div class="flex items-center justify-between flex-wrap gap-x-1 gap-y-3">
            <div>
                <div class="titleWithBorder flex items-center gap-1.5 !mb-1 justify-between">{{LABELS.FEATURE_PRICING}}
                </div>
            </div>
        </div>
        <div class="modal-inner p-5">
            <form (ngSubmit)="addEdit()" [formGroup]="configForm" class="w-full" id="ngForm" name="configForm"
                novalidate>
                <mat-card-content class="site-card-inner">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-2">
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">Feed Try-On:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="freeTryOn"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">Wardrobe Try-On:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="wardrobeTryOn"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">Surprise Me:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="surpriseMe"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">Daily Image Generation:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="dailyImageGeneration"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">Video Try-On</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="videoTryOn"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </mat-card-content>
            </form>
        </div>
    </div>
    <div class="whiteCard  p-5 my-2">
        <div class="flex items-center justify-between flex-wrap gap-x-1 gap-y-3">
            <div>
                <div class="titleWithBorder flex items-center gap-1.5 !mb-1 justify-between">
                    {{LABELS.SUBSCRIPTION_ALLOCATION}}
                </div>
            </div>
        </div>
        <div class="modal-inner p-5">
            <form (ngSubmit)="addEdit()" [formGroup]="configForm" class="w-full" id="ngForm" name="configForm"
                novalidate>
                <mat-card-content class="site-card-inner">
                    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-2">
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">Standard Subscribers:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="standardSubscribers"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="flex flex-col gap-2">
                            <div class="w-full flex gap-2 items-center justify-between">
                                <span class=" mb-5 font-bold">Premium Subscribers:</span>
                                <mat-form-field appearance="outline"
                                    class="input-wrapper w-full max-w-[80px] !text-center conversion-input">
                                    <input matInput type="number" min="0" formControlName="premiumSubscribers"
                                        (keydown)="_helper.space($event); preventNegativeInput($event)">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>


                </mat-card-content>
            </form>
        </div>
    </div>

    <div class="whiteCard  p-5 my-2">
        <div class="flex items-center justify-between flex-wrap gap-x-1 gap-y-3">
            <div>
                <div class="titleWithBorder flex items-center gap-1.5 !mb-1 justify-between">
                    Avatar Items (Male)
                </div>
            </div>
        </div>
        <div class="modal-inner p-5">
            <form (ngSubmit)="addEdit()" [formGroup]="configForm" class="w-full" id="ngForm" name="configForm"
                novalidate>
                <mat-card-content class="site-card-inner">
                    <div class="mt-5" formArrayName="avatarItemsMale">
                        @for (avatarItem of avatarItemsMale.controls; track avatarItem; let i = $index) {
                        <div class="grid grid-cols-1 md:grid-cols-[1fr_3fr] gap-4 items-center mb-3"
                            [formGroupName]="i">
                            <div class="font-bold text-base capitalize min-w-[120px]">{{
                                i === 1 ? 'One Piece' : getItemTypeName(avatarItem.get('itemTypeId')?.value) }}</div>
                            <mat-form-field appearance="outline" class="input-wrapper w-full !mb-0">
                                <mat-label>Items</mat-label>
                                <mat-select formControlName="items" multiple>
                                    @for (item of itemsByType[getItemsByTypeKey(avatarItem.get('itemTypeId')?.value, 'male', i)]; track
                                    item.itemId) {
                                    <mat-option [value]="item.itemId">
                                        <span class="flex items-center gap-3 py-1">
                                            <span
                                                class="avatar-thumbnail relative flex w-10 h-10 shrink-0 items-center justify-center">
                                                <img [appAvatarImage]="item.imageUrl"
                                                    [alt]="item.itemNameEn || item.itemName || item.name || 'Product'"
                                                    width="40" height="40" loading="lazy" decoding="async"
                                                    class="w-10 h-10 object-contain rounded">
                                                <span class="avatar-thumbnail-loader" role="status"
                                                    aria-label="Loading item image"></span>
                                            </span>
                                            <span>{{ item.itemNameEn || item.itemName || item.name }}</span>
                                        </span>
                                    </mat-option>
                                    }
                                </mat-select>
                                @if (loadingItemsByType[getItemsByTypeKey(avatarItem.get('itemTypeId')?.value, 'male', i)]) {
                                <mat-hint>Loading items...</mat-hint>
                                }
                            </mat-form-field>
                        </div>
                        }
                    </div>
                </mat-card-content>
            </form>
        </div>
    </div>

    <div class="whiteCard  p-5 my-2">
        <div class="flex items-center justify-between flex-wrap gap-x-1 gap-y-3">
            <div>
                <div class="titleWithBorder flex items-center gap-1.5 !mb-1 justify-between">
                    Avatar Items (Female)
                </div>
            </div>
        </div>
        <div class="modal-inner p-5">
            <form (ngSubmit)="addEdit()" [formGroup]="configForm" class="w-full" id="ngForm" name="configForm"
                novalidate>
                <mat-card-content class="site-card-inner">
                    <div class="mt-5" formArrayName="avatarItemsFemale">
                        @for (avatarItem of avatarItemsFemale.controls; track avatarItem; let i = $index) {
                        <div class="grid grid-cols-1 md:grid-cols-[1fr_3fr] gap-4 items-center mb-3"
                            [formGroupName]="i">
                            <div class="font-bold text-base capitalize min-w-[120px]">{{
                                i === 1 ? 'One Piece' : getItemTypeName(avatarItem.get('itemTypeId')?.value) }}</div>
                            <mat-form-field appearance="outline" class="input-wrapper w-full !mb-0">
                                <mat-label>Items</mat-label>
                                <mat-select formControlName="items" multiple>
                                    @for (item of itemsByType[getItemsByTypeKey(avatarItem.get('itemTypeId')?.value, 'female', i)]; track
                                    item.itemId) {
                                    <mat-option [value]="item.itemId">
                                        <span class="flex items-center gap-3 py-1">
                                            <span
                                                class="avatar-thumbnail relative flex w-10 h-10 shrink-0 items-center justify-center">
                                                <img [appAvatarImage]="item.imageUrl"
                                                    [alt]="item.itemNameEn || item.itemName || item.name || 'Product'"
                                                    width="40" height="40" loading="lazy" decoding="async"
                                                    class="w-10 h-10 object-contain rounded">
                                                <span class="avatar-thumbnail-loader" role="status"
                                                    aria-label="Loading item image"></span>
                                            </span>
                                            <span>{{ item.itemNameEn || item.itemName || item.name }}</span>
                                        </span>
                                    </mat-option>
                                    }
                                </mat-select>
                                @if (loadingItemsByType[getItemsByTypeKey(avatarItem.get('itemTypeId')?.value, 'female', i)]) {
                                <mat-hint>Loading items...</mat-hint>
                                }
                            </mat-form-field>
                        </div>
                        }
                    </div>
                </mat-card-content>
            </form>
        </div>
    </div>

    <div class="whiteCard my-2">
        <div class="modal-inner">
            <form (ngSubmit)="addEdit()" [formGroup]="configForm" class="w-full" id="ngForm" name="configForm"
                novalidate>
                <mat-card-content class="site-card-inner">
                    <div class="flex w-full items-center justify-end gap-2 px-8 py-4">
                        <button mat-flat-button [disabled]="isLoad"
                            class="btn-theme-color !min-w-[90px]">{{LABELS.UPDATE}}</button>
                    </div>
                </mat-card-content>
            </form>
        </div>
    </div>
</div>